import { api_configuration } from "../../common";
import api_views = api_configuration.libraries.gui_definition_lib.types.views.alan_api;
import { CollectionPathBuilder } from "../navigation/createCollectionPathBuilder";

function walkQueryPathStep(
	query_path_step: api_views.Cquery_path_step,
	path_builder: CollectionPathBuilder
): CollectionPathBuilder {
	return query_path_step.properties.has_steps.switch({
		no: function () {
			return path_builder;
		},
		yes: function (has_steps) {
			return has_steps.properties.type.switch({
				state: function (type_state) {
					return walkQueryPathStep(
						has_steps.properties.tail,
						path_builder.state(
							type_state.properties.state_group.ref.parent.parent.key.ref.key,
							type_state.properties.state.ref.key.ref.key
						)
					);
				},
				group: function (type_group) {
					return walkQueryPathStep(
						has_steps.properties.tail,
						path_builder.group(type_group.properties.group.ref.parent.parent.key.ref.key)
					);
				},
			});
		},
	});
}

export function create(path: api_views.Cquery_path, path_builder: CollectionPathBuilder): CollectionPathBuilder {
	return path.properties.has_steps.switch({
		no: () => path_builder,
		yes: function (has_steps) {
			const collection_builder = walkQueryPathStep(has_steps.properties.head, path_builder).collection(
				has_steps.properties.collection.entry
			);
			return create(has_steps.properties.tail, collection_builder);
		},
	});
}
